var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrackingCarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 59,
    viewBox: "0 0 35 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_30241_138007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3962 15.2801L26.2879 13.5576C26.1886 12.0056 25.7012 10.4984 24.8257 9.2155C23.2192 6.87398 20.8726 5.93199 17.4158 5.79742H14.6811C11.2334 5.93199 8.87775 6.87398 7.28025 9.2155C6.40478 10.4984 5.9174 12.0056 5.81812 13.5576L5.70981 15.2801C5.63761 16.3926 5.65566 17.514 5.77299 18.6264L5.80007 18.8776L5.80007 46.8951C5.87227 48.5279 6.17011 49.3801 6.69359 50.7258C7.65931 52.9507 9.67199 53.9466 15.0963 53.9735H17.0187C22.443 53.9466 24.4557 52.9418 25.4214 50.7258C25.9449 49.3801 26.2337 48.5279 26.315 46.8951L26.315 18.8866L26.342 18.6354C26.4413 17.523 26.4594 16.4015 26.3962 15.2801ZM24.3655 20.1516L23.1651 26.2521C23.0838 26.6647 23.0116 27.0774 22.9485 27.4901C17.6325 26.3597 14.4284 26.2431 9.04924 27.4901C8.98606 27.0774 8.91385 26.6647 8.83263 26.2521L7.63224 20.1516C7.3705 18.8328 8.08351 17.514 9.33805 17.0206C10.9987 16.3657 12.9212 16.0786 15.4934 16.0068H16.4862C19.0585 16.0786 20.9899 16.3746 22.6416 17.0295C23.9142 17.514 24.6272 18.8328 24.3655 20.1516Z",
    fill: "url(#paint0_linear_30241_138007)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30241_138007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.602 40.0527C11.6516 40.0529 11.6962 40.0434 11.7442 40.0387C12.1425 39.979 12.6994 39.9295 13.1437 39.471C13.4753 39.1359 13.7696 38.6044 13.7736 37.4959C13.7766 36.6336 13.8135 36.0159 13.8135 36.0159C13.8424 35.6269 13.9163 35.2423 14.034 34.8696C14.1936 34.3376 14.4173 33.8259 14.7002 33.3451L13.6613 32.3858L17.6101 31.7402L17.1419 35.6143L16.1294 34.6743C15.7935 35.1996 15.5637 35.7825 15.4525 36.3918C15.4036 36.6697 15.3777 36.951 15.3752 37.233L15.3922 37.5548C15.4666 37.5551 15.5409 37.5553 15.6152 37.5556C16.4078 37.5584 17.1834 37.3321 17.8438 36.9053C18.5041 36.4785 19.0195 35.8704 19.3247 35.158C19.6298 34.4456 19.7111 33.661 19.5581 32.9036C19.405 32.1462 19.0247 31.4499 18.4651 30.9031C17.9056 30.3563 17.192 29.9835 16.4149 29.8319C15.6377 29.6802 14.8318 29.7567 14.0993 30.0514C13.3668 30.3462 12.7407 30.8461 12.3002 31.4878C11.8597 32.1294 11.6247 32.884 11.6249 33.6559L11.602 40.0527Z",
    fill: "#3C63AD"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.0894 7.12555L10.2319 16.7249H10.3402L11.5406 7.17938C11.333 7.17938 11.1796 7.18835 11.0894 7.12555Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0081 7.12555L21.8655 16.7249H21.7572L20.5659 7.17938C20.7644 7.17938 20.9178 7.18835 21.0081 7.12555Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7693 45.2544C23.7693 46.3309 23.6519 47.2012 23.3812 47.9009C23.3631 47.8292 23.327 47.7574 23.2819 47.6856C23.1826 47.9368 23.0743 48.1701 22.966 48.3943C22.605 49.1031 21.9642 49.6234 21.206 49.8746C20.0147 50.2604 18.8955 50.4039 17.3522 50.5116C16.9641 50.5385 16.585 50.5475 16.1969 50.5475H15.9442C15.5651 50.5475 15.186 50.5385 14.816 50.5116C13.2636 50.4039 12.1445 50.2604 10.9441 49.8746C10.1859 49.6324 9.55415 49.1031 9.18411 48.3943C9.06678 48.1701 8.9675 47.9368 8.85919 47.6766C8.82309 47.7305 8.79602 47.7843 8.76894 47.8471C8.48915 47.1563 8.36279 46.304 8.36279 45.2544C8.36279 44.7968 8.38987 44.3303 8.435 43.8638H23.688C23.7512 44.3393 23.7693 44.7968 23.7693 45.2544Z",
    fill: "#4B545A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7693 45.2544C23.7693 46.3309 23.6519 47.2012 23.3812 47.9009C23.3631 47.8292 23.327 47.7574 23.2819 47.6856C23.1826 47.9368 23.0743 48.1701 22.966 48.3943C22.605 49.1031 21.9642 49.6234 21.206 49.8746C20.0147 50.2604 18.8955 50.4039 17.3522 50.5116C16.9641 50.5385 16.585 50.5475 16.1969 50.5475H15.9442C15.5651 50.5475 15.186 50.5385 14.816 50.5116C13.2636 50.4039 12.1445 50.2604 10.9441 49.8746C10.1859 49.6324 9.55415 49.1031 9.18411 48.3943C9.06678 48.1701 8.9675 47.9368 8.85919 47.6766C8.82309 47.7305 8.79602 47.7843 8.76894 47.8471C8.48915 47.1563 8.36279 46.304 8.36279 45.2544C8.36279 44.7968 8.38987 44.3303 8.435 43.8638H23.688C23.7512 44.3393 23.7693 44.7968 23.7693 45.2544Z",
    fill: "#4388FC",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7693 45.2544C23.7693 46.3309 23.6519 47.2012 23.3812 47.9009C23.3631 47.8292 23.327 47.7574 23.2819 47.6856C23.1826 47.9368 23.0743 48.1701 22.966 48.3943C22.605 49.1031 21.9642 49.6234 21.206 49.8746C20.0147 50.2604 18.8955 50.4039 17.3522 50.5116C16.9641 50.5385 16.585 50.5475 16.1969 50.5475H15.9442C15.5651 50.5475 15.186 50.5385 14.816 50.5116C13.2636 50.4039 12.1445 50.2604 10.9441 49.8746C10.1859 49.6324 9.55415 49.1031 9.18411 48.3943C9.06678 48.1701 8.9675 47.9368 8.85919 47.6766C8.82309 47.7305 8.79602 47.7843 8.76894 47.8471C8.48915 47.1563 8.36279 46.304 8.36279 45.2544C8.36279 44.7968 8.38987 44.3303 8.435 43.8638H23.688C23.7512 44.3393 23.7693 44.7968 23.7693 45.2544Z",
    fill: "url(#paint1_radial_30241_138007)",
    fillOpacity: 0.77
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.70632 41.5202C8.68827 42.3456 8.67022 43.1978 8.65217 44.1398C8.65217 44.2116 8.63412 44.2834 8.59801 44.3462C8.44458 44.6333 8.22797 44.7319 7.885 44.6691C7.3886 44.5166 7.13589 44.0591 7.11784 43.2517L6.63046 20.7067C6.63046 20.6888 6.63046 20.6708 6.63046 20.6529C6.63949 20.6619 6.64851 20.6798 6.65754 20.6977L6.91928 21.2001C6.97343 21.3078 7.01856 21.4244 7.04563 21.55L7.78572 25.4256C8.3092 28.1709 8.58899 30.6021 8.62509 32.8808C8.81463 36.3707 8.7695 38.757 8.70632 41.5202Z",
    fill: "#4B545A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.70629 41.5202C8.68824 42.3456 8.67019 43.1979 8.65214 44.1399C8.65214 44.2116 8.63409 44.2834 8.59798 44.3462C8.44455 44.6333 8.22794 44.732 7.88497 44.6692C7.38857 44.5166 7.13586 44.0591 7.11781 43.2517L6.63043 20.7067C6.63043 20.6888 6.63043 20.6709 6.63043 20.6529C6.63946 20.6619 6.64848 20.6798 6.65751 20.6978L6.91925 21.2002C6.9734 21.3078 7.01853 21.4244 7.0456 21.55L7.78569 25.4257C8.30917 28.1709 8.58896 30.6021 8.62506 32.8808C8.81459 36.3707 8.76947 38.7571 8.70629 41.5202Z",
    fill: "#4388FC",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.70629 41.5202C8.68824 42.3456 8.67019 43.1979 8.65214 44.1399C8.65214 44.2116 8.63409 44.2834 8.59798 44.3462C8.44455 44.6333 8.22794 44.732 7.88497 44.6692C7.38857 44.5166 7.13586 44.0591 7.11781 43.2517L6.63043 20.7067C6.63043 20.6888 6.63043 20.6709 6.63043 20.6529C6.63946 20.6619 6.64848 20.6798 6.65751 20.6978L6.91925 21.2002C6.9734 21.3078 7.01853 21.4244 7.0456 21.55L7.78569 25.4257C8.30917 28.1709 8.58896 30.6021 8.62506 32.8808C8.81459 36.3707 8.76947 38.7571 8.70629 41.5202Z",
    fill: "url(#paint2_radial_30241_138007)",
    fillOpacity: 0.77
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.92839 34.3435C7.51505 34.6665 7.94827 34.7831 8.71543 34.8728L8.66128 33.5002C7.97534 33.1324 7.46992 32.7735 6.87424 32.1725L6.92839 34.3435Z",
    fill: "#4B545A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.41611 23.4699L6.69408 23.2815L6.63992 20.7068C6.63992 20.6888 6.63992 20.6709 6.63992 20.6529C6.64895 20.6619 6.65797 20.6798 6.667 20.6978L6.92874 21.2002C6.98289 21.3078 7.02802 21.4245 7.05509 21.5501L7.41611 23.4699Z",
    fill: "#4B545A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4001 41.5203C23.4181 42.3457 23.4362 43.1979 23.4542 44.1399C23.4542 44.2117 23.4723 44.2835 23.5084 44.3463C23.6618 44.6334 23.8784 44.732 24.2214 44.6692C24.7178 44.5167 24.9705 44.0592 24.9886 43.2518L25.476 20.7068C25.476 20.6889 25.476 20.6709 25.476 20.653C25.4669 20.662 25.4579 20.6799 25.4489 20.6979L25.1871 21.2003C25.133 21.3079 25.0879 21.4245 25.0608 21.5501L24.3117 25.4437C23.7882 28.1889 23.5084 30.6201 23.4723 32.8989C23.2828 36.3708 23.3369 38.7571 23.4001 41.5203Z",
    fill: "#4B545A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4001 41.5202C23.4181 42.3456 23.4362 43.1978 23.4542 44.1398C23.4542 44.2116 23.4723 44.2834 23.5084 44.3462C23.6618 44.6333 23.8784 44.7319 24.2214 44.6691C24.7178 44.5166 24.9705 44.0591 24.9886 43.2517L25.476 20.7067C25.476 20.6888 25.476 20.6708 25.476 20.6529C25.4669 20.6619 25.4579 20.6798 25.4489 20.6977L25.1871 21.2001C25.133 21.3078 25.0879 21.4244 25.0608 21.55L24.3117 25.4436C23.7882 28.1888 23.5084 30.62 23.4723 32.8988C23.2828 36.3707 23.3369 38.757 23.4001 41.5202Z",
    fill: "#4388FC",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4001 41.5202C23.4181 42.3456 23.4362 43.1978 23.4542 44.1398C23.4542 44.2116 23.4723 44.2834 23.5084 44.3462C23.6618 44.6333 23.8784 44.7319 24.2214 44.6691C24.7178 44.5166 24.9705 44.0591 24.9886 43.2517L25.476 20.7067C25.476 20.6888 25.476 20.6708 25.476 20.6529C25.4669 20.6619 25.4579 20.6798 25.4489 20.6977L25.1871 21.2001C25.133 21.3078 25.0879 21.4244 25.0608 21.55L24.3117 25.4436C23.7882 28.1888 23.5084 30.62 23.4723 32.8988C23.2828 36.3707 23.3369 38.757 23.4001 41.5202Z",
    fill: "url(#paint3_radial_30241_138007)",
    fillOpacity: 0.77
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.178 34.3513C24.5914 34.6743 24.1582 34.7909 23.391 34.8806L23.4451 33.508C24.1311 33.1402 24.6365 32.7813 25.2322 32.1802L25.178 34.3513Z",
    fill: "#4B545A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6903 23.4777L25.4123 23.2893L25.4665 20.7145C25.4665 20.6966 25.4665 20.6786 25.4665 20.6607C25.4575 20.6697 25.4484 20.6876 25.4394 20.7056L25.1777 21.208C25.1235 21.3156 25.0784 21.4322 25.0513 21.5578L24.6903 23.4777Z",
    fill: "#4B545A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.93753 21.9459C6.99168 22.1612 6.98266 22.2868 6.93753 22.4931H6.18842V21.9459H6.93753Z",
    fill: "#594F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.31471 22.0993L6.30569 22.8529C6.30569 22.9337 6.25154 23.0054 6.17031 23.0324L4.22081 23.6783C4.15763 23.6962 4.08542 23.6604 4.06737 23.5976C4.0403 23.4989 4.01322 23.3912 4.00419 23.2566C3.99517 23.1669 4.00419 23.0772 4.00419 23.0054C4.02225 22.8171 4.09445 22.6376 4.21178 22.4941C4.32009 22.3685 4.45547 22.2429 4.66305 22.1442C4.92479 22.0186 5.27679 21.9468 5.62878 21.9379C5.79124 21.9289 5.99882 21.9379 6.16128 21.9468C6.25154 21.9468 6.31471 22.0186 6.31471 22.0993Z",
    fill: "#594F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1598 21.9459C25.1057 22.1612 25.1147 22.2868 25.1598 22.4931H25.9089V21.9459H25.1598Z",
    fill: "#594F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7826 22.1072L25.7916 22.8607C25.7916 22.9415 25.8458 23.0133 25.927 23.0402L27.8765 23.6861C27.9397 23.7041 28.0119 23.6682 28.0299 23.6054C28.057 23.5067 28.0841 23.399 28.0931 23.2645C28.1021 23.1747 28.0931 23.085 28.0931 23.0133C28.0751 22.8249 28.0029 22.6454 27.8855 22.5019C27.7772 22.3763 27.6418 22.2507 27.4343 22.152C27.1725 22.0264 26.8205 21.9546 26.4685 21.9457C26.3061 21.9367 26.0985 21.9457 25.936 21.9546C25.8458 21.9546 25.7826 22.0174 25.7826 22.1072Z",
    fill: "#594F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4123 7.44977C8.50788 8.60707 7.43385 9.96174 6.8833 12.1149L6.8833 11.0383C6.8833 10.4013 7.09991 9.79128 7.51508 9.30683C8.32737 8.37381 9.12161 7.76376 10.4123 7.44977Z",
    fill: "url(#paint4_linear_30241_138007)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4123 7.44977C8.50788 8.60707 7.43385 9.96174 6.8833 12.1149L6.8833 11.0383C6.8833 10.4013 7.09991 9.79128 7.51508 9.30683C8.32737 8.37381 9.12161 7.76376 10.4123 7.44977Z",
    fill: "url(#paint5_linear_30241_138007)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.89328 12.1059L6.89328 11.0383C6.89328 10.4013 7.10989 9.79129 7.52506 9.30683C8.32833 8.37382 9.12257 7.76376 10.4132 7.44977C8.50884 8.60707 7.43481 9.95277 6.89328 12.1059Z",
    fill: "#D5E3F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.604 7.44977C23.5084 8.60707 24.5824 9.96174 25.133 12.1149V11.0383C25.133 10.4013 24.9164 9.79129 24.5012 9.30683C23.6979 8.37382 22.8946 7.76376 21.604 7.44977Z",
    fill: "url(#paint6_linear_30241_138007)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.604 7.44977C23.5084 8.60707 24.5824 9.96174 25.133 12.1149V11.0383C25.133 10.4013 24.9164 9.79129 24.5012 9.30683C23.6979 8.37382 22.8946 7.76376 21.604 7.44977Z",
    fill: "url(#paint7_linear_30241_138007)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1327 12.1031V11.0356C25.1327 10.3986 24.9161 9.78854 24.5009 9.30409C23.6977 8.3621 22.8944 7.75205 21.6038 7.43805C23.5081 8.60432 24.5822 9.95002 25.1327 12.1031Z",
    fill: "#D5E3F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2044 53.5039C8.26392 53.0015 7.28015 52.0954 6.68447 50.7318C6.53103 50.337 6.39565 49.9782 6.27832 49.6373L6.45883 49.6911C7.06354 49.8795 7.55091 50.3191 7.80362 50.8933C8.20977 51.8263 8.63397 52.23 9.86143 52.858C10.1051 52.9836 10.2405 53.2437 10.2044 53.5039Z",
    fill: "#D8394C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8926 53.5079C23.8331 53.0055 24.8169 52.0994 25.4126 50.7357C25.566 50.341 25.7014 49.9821 25.8187 49.6412L25.6382 49.695C25.0335 49.8834 24.5461 50.323 24.2934 50.8972C23.8873 51.8302 23.4631 52.2339 22.2356 52.8619C21.9919 52.9875 21.8565 53.2477 21.8926 53.5079Z",
    fill: "#D8394C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4949 18.1949C19.1303 18.2666 21.0076 18.5806 22.569 19.1997C23.2459 19.4688 23.7694 20.0071 24.0221 20.6799L22.93 26.2063C22.8668 26.5382 22.8037 26.8791 22.7495 27.2111C19.9065 26.619 17.8306 26.3678 15.8541 26.3678C13.8504 26.3678 11.7926 26.6279 9.2384 27.2111C9.18425 26.8791 9.13009 26.5382 9.05789 26.2063L7.97484 20.6799C8.22755 20.0071 8.75103 19.4688 9.42793 19.1997C10.9984 18.5806 12.8666 18.2756 15.5021 18.1949H16.4949ZM16.4949 17.9616H15.5021C12.9298 18.0334 10.9984 18.3294 9.34671 18.9754C8.57052 19.2804 7.99289 19.9084 7.74017 20.653L8.84128 26.2511C8.92251 26.6638 8.99471 27.0765 9.05789 27.4892C11.6843 26.8791 13.7872 26.601 15.8721 26.601C18.0653 26.601 20.2314 26.915 22.9661 27.4892C23.0293 27.0765 23.1015 26.6638 23.1827 26.2511L24.2838 20.662C24.0221 19.9174 23.4535 19.2894 22.6773 18.9844C20.9986 18.3294 19.0671 18.0334 16.4949 17.9616Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2661 20.6646L23.165 26.2537C23.0838 26.6664 23.0116 27.0791 22.9484 27.4918C17.6324 26.3614 14.4283 26.2448 9.04916 27.4918C8.98599 27.0791 8.91378 26.6664 8.83255 26.2537L7.73145 20.6646C7.99318 19.92 8.56179 19.292 9.33798 18.987C10.9987 18.3321 12.9211 18.045 15.4933 17.9732H16.4861C19.0584 18.045 20.9899 18.341 22.6415 18.9959C23.4358 19.292 24.0044 19.92 24.2661 20.6646Z",
    fill: "#4B545A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2661 20.6646L23.165 26.2537C23.0838 26.6664 23.0116 27.0791 22.9484 27.4918C17.6324 26.3614 14.4283 26.2448 9.04916 27.4918C8.98599 27.0791 8.91378 26.6664 8.83255 26.2537L7.73145 20.6646C7.99318 19.92 8.56179 19.292 9.33798 18.987C10.9987 18.3321 12.9211 18.045 15.4933 17.9732H16.4861C19.0584 18.045 20.9899 18.341 22.6415 18.9959C23.4358 19.292 24.0044 19.92 24.2661 20.6646Z",
    fill: "#4388FC",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2661 20.6646L23.165 26.2537C23.0838 26.6664 23.0116 27.0791 22.9484 27.4918C17.6324 26.3614 14.4283 26.2448 9.04916 27.4918C8.98599 27.0791 8.91378 26.6664 8.83255 26.2537L7.73145 20.6646C7.99318 19.92 8.56179 19.292 9.33798 18.987C10.9987 18.3321 12.9211 18.045 15.4933 17.9732H16.4861C19.0584 18.045 20.9899 18.341 22.6415 18.9959C23.4358 19.292 24.0044 19.92 24.2661 20.6646Z",
    fill: "url(#paint8_radial_30241_138007)",
    fillOpacity: 0.77
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3653 20.1504C24.6271 18.8316 23.9141 17.5128 22.6595 17.0194C20.9988 16.3645 19.0764 16.0774 16.5042 15.9966L15.5114 15.9966C12.9391 16.0684 11.0077 16.3645 9.356 17.0104C8.10146 17.5038 7.38845 18.8226 7.65018 20.1414L7.74946 20.6528C8.0112 19.9081 8.57981 19.2801 9.356 18.9751C11.0167 18.3202 12.9391 18.0331 15.5114 17.9614H16.5042C19.0764 18.0331 21.0079 18.3292 22.6595 18.9841C23.4357 19.2891 24.0134 19.9171 24.2661 20.6617L24.3653 20.1504Z",
    fill: "#4B545A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9266 6.97151C20.9266 6.98048 20.8905 6.99842 20.7913 6.99842L11.3145 6.99842C11.2152 6.99842 11.1791 6.97151 11.1791 6.97151C11.1791 6.96254 11.1972 6.90871 11.3055 6.83694L11.3867 6.78311C11.8651 6.45117 12.2171 6.20895 12.8037 5.97569C13.3904 5.88598 14.0131 5.83215 14.681 5.80524L17.4157 5.80524C18.0836 5.83215 18.7064 5.88598 19.293 5.97569C19.293 5.97569 19.293 5.97569 19.3021 5.97569C19.8887 6.20895 20.2407 6.45117 20.7191 6.78311L20.8003 6.83694C20.9086 6.90871 20.9266 6.96254 20.9266 6.97151Z",
    fill: "#4B545A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.65233 42.7623H23.4541C23.4541 42.7623 23.5735 43.8176 22.9577 44.9602C21.6039 47.4722 10.1415 47.3376 9.10361 44.9602C8.58444 43.7711 8.65233 42.7623 8.65233 42.7623Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_30241_138007",
    x: 0,
    y: 0.797424,
    width: 34.0971,
    height: 58.194,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_30241_138007"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_30241_138007",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_30241_138007",
    x1: 16.05,
    y1: 5.79742,
    x2: 16.05,
    y2: 53.9735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_30241_138007",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.4586 43.3884) rotate(90) scale(7.67048 25.4977)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_30241_138007",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.71108 46.5673) rotate(90.0336) scale(26.2698 3.35888)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_30241_138007",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.4241 46.5673) rotate(90.0336) scale(26.2698 3.36541)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_30241_138007",
    x1: 6.88855,
    y1: 9.7775,
    x2: 10.4165,
    y2: 9.7775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1548,
    stopColor: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9205,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_30241_138007",
    x1: 6.88855,
    y1: 9.7775,
    x2: 10.4165,
    y2: 9.7775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1883
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3849,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5983
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8033,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_30241_138007",
    x1: 25.1339,
    y1: 9.77751,
    x2: 21.6059,
    y2: 9.77751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1548,
    stopColor: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9205,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_30241_138007",
    x1: 25.1339,
    y1: 9.77751,
    x2: 21.6059,
    y2: 9.77751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1883
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3849,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5983
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8033,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_30241_138007",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.1182 28.2364) rotate(90.6579) scale(10.4046 26.0663)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30241_138007"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.00851,
    height: 10.2967,
    fill: "white",
    transform: "translate(11.6388 29.7572) rotate(0.204509)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackingCarIcon);
export default __webpack_public_path__ + "static/media/trackingCarIcon.9ee105bdbd52c55d809ed85690d2f108.svg";
export { ForwardRef as ReactComponent };